// Typed client for the Guide Studio REST API (/v1/studio/guides/*).
// See app/api/studio_guides_router.py.

import { apiBlob, apiRequest } from "./http";
import type { CharacterProfile, DomainCatalog, VoiceCatalog } from "../types/guide";

export const listGuides = () => apiRequest<CharacterProfile[]>("/studio/guides");

export const getGuide = (id: string) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(id)}`);

export const createGuide = (profile: CharacterProfile) =>
  apiRequest<CharacterProfile>("/studio/guides", { method: "POST", body: profile });

export const updateGuide = (profile: CharacterProfile) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(profile.id)}`, {
    method: "PUT",
    body: profile,
  });

export const archiveGuide = (id: string) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(id)}`, { method: "DELETE" });

export const publishGuide = (id: string) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(id)}/publish`, { method: "POST" });

export const unpublishGuide = (id: string) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(id)}/unpublish`, { method: "POST" });

export const setGuideEnabled = (id: string, enabled: boolean) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(id)}/enabled`, {
    method: "POST",
    body: { enabled },
  });

export const previewPrompt = (profile: CharacterProfile) =>
  apiRequest<{ prompt: string; guidePrompt: string }>("/studio/guides/preview-prompt", {
    method: "POST",
    body: { profile },
  });

export const listVoices = () =>
  apiRequest<{ providers: VoiceCatalog; servableProviders: string[]; liveVoices: string[] }>(
    "/studio/guides/voices",
  );

export const listDomains = () => apiRequest<DomainCatalog>("/studio/guides/domains");

export const previewVoice = (provider: string | null, voiceId: string, text: string) =>
  apiBlob("/studio/guides/preview-voice", {
    method: "POST",
    body: { provider, voiceId, text },
  });

export const generateVoicePreview = (guideId: string, text: string) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(guideId)}/generate-voice-preview`, {
    method: "POST",
    body: { text },
  });

export const generateAvatar = (guideId: string, customPrompt?: string) =>
  apiRequest<CharacterProfile>(`/studio/guides/${encodeURIComponent(guideId)}/generate-avatar`, {
    method: "POST",
    body: { customPrompt },
  });

export const testTurn = (sessionId: string | null, message: string, profile: CharacterProfile) =>
  apiRequest<{ sessionId: string; reply: string }>("/studio/guides/test-turn", {
    method: "POST",
    body: { sessionId, message, profile },
  });
